import { useEffect, useState } from "react";
import {
  Typography,
  Divider,
  Form,
  Tree,
  Input,
  Empty,
  Button,
  Collapse,
  Tooltip,
  DatePicker,
  Select,
} from "antd";
import {
  convertCategoriesToTreeNodes,
  remainingViewportHeight,
} from "../../../components/icons/ApplicationColor";
import {
  CloseOutlined,
  FilterOutlined,
  InteractionTwoTone,
  SearchOutlined,
  CaretDownOutlined,
  DownOutlined,
  RightOutlined,
} from "@ant-design/icons";
import CourseFilterHelper from "./CourseFilterHelper";
import moment from "moment";
import dayjs from "dayjs";
// import { duration } from "moment";
const { Panel } = Collapse;
const { RangePicker } = DatePicker;
const { Option } = Select;
const RecordsFiltersSplitter = ({
  form,
  handleDecodedFormValues,
  setShowFilter,
  handleClearAll,
  languages,
  categories,
  modes,
  states,
  categorySearch,
  setCategorySearch,
  checkedKeys,
  handleCheck,
  filter_url,
  origin,
}) => {
  const [filterVisibility, setFilterVisibility] = useState({
    language: false,
    state: true,
    mode: false,
    categories: true,
    source_app: false,
    dateRange: false,
  });
  const toggleFilter = (key) => {
    console.log(key);
    setFilterVisibility((prev) => ({
      ...prev,
      [key]: !prev[key],
    }));
  };
  // const isInitialized = useRef(false);

  useEffect(() => {
    if (!filter_url) return;

    const searchParams = new URLSearchParams(
      filter_url.split("?")[1] || filter_url
    );

    const initialValues = {};
    searchParams.forEach((value, key) => {
      // Handle date_range specially - convert to dayjs array
      if (key === "date_range") {
        const dateArray = value.split(",").map((d) => d.trim());
        if (dateArray.length === 2 && dateArray[0] && dateArray[1]) {
          // Parse strictly as YYYY-MM-DD to avoid defaulting to today
          const startDay = dayjs(dateArray[0], "YYYY-MM-DD", true);
          const endDay = dayjs(dateArray[1], "YYYY-MM-DD", true);
          if (startDay.isValid() && endDay.isValid()) {
            initialValues.dateRange = [
              startDay.startOf("day"),
              endDay.startOf("day"),
            ];
          }
        }
      } else if (key === "date_type") {
        // date_type is a single value, not an array
        initialValues[key] = value;
      } else {
        const valArray = value.includes(",")
          ? value.split(",").map((v) => v.trim())
          : [value.trim()];
        initialValues[key] = valArray;
      }
    });
    console.log("Parsed initial values from URL:", initialValues);
    form.setFieldsValue(initialValues); // Values are now always arrays
  }, [filter_url, form]);

  const resetFilters = () => {
    form.resetFields(); // Clears all fields
    handleClearAll();
  };
  const handleClearFilter = (fieldName) => {
    // Clear the selected field
    if (fieldName === "dateRange" || fieldName === "date_type") {
      form.setFieldsValue({ date_type: undefined, dateRange: undefined });
    } else {
      form.setFieldsValue({ [fieldName]: [] });
    }

    // Get all form values and process duration
    const allValues = form.getFieldsValue();

    // Trigger your existing function
    handleDecodedFormValues(allValues);
  };
  return (
    <div
      style={{
        background: "#f0f2f5",
        padding: "0.75rem",
        margin: 0,
        borderRight: "1px solid #d9d9d9",
        height: `${remainingViewportHeight(14)}px`,
        overflowY: "auto",
      }}
    >
      <Form
        form={form}
        layout="vertical"
        onValuesChange={(_, allValues) => {
          handleDecodedFormValues(allValues);
        }}
      >
        <div
          style={{
            display: "flex",
            justifyContent: "space-between",
            marginInline: "7.5px",
            marginLeft: "10px",
            marginTop: "7.5px",
            marginBottom: "17.5px",
          }}
        >
          <div style={{ display: "flex", alignItems: "center", gap: 5 }}>
            <FilterOutlined style={{ fontSize: 17 }} />
            <Typography.Title level={5} style={{ margin: 0 }}>
              Apply Filters
            </Typography.Title>
          </div>
          <div style={{ display: "flex", alignItems: "center", gap: 10 }}>
            {filter_url && (
              <Tooltip title="Clear All Filters">
                <InteractionTwoTone
                  onClick={resetFilters}
                  // twoToneColor="#ff4d4f"
                  style={{ fontSize: 21, cursor: "pointer" }}
                />
              </Tooltip>
            )}
            <Tooltip title="Close Filter Panel">
              <CloseOutlined
                onClick={() => setShowFilter(false)}
                style={{ fontSize: 16, cursor: "pointer" }}
              />
            </Tooltip>
          </div>
        </div>

        <Divider style={{ marginTop: 10, marginBottom: 10 }} />
        <CourseFilterHelper
          title="Record State"
          name="state"
          items={states}
          valueKey="state"
          labelKey="state"
          form={form}
          showClear={true}
          onClear={() => handleClearFilter("state")}
          isVisible={filterVisibility.state}
          toggle={toggleFilter}
        />

        <Divider style={{ marginTop: 10, marginBottom: 10 }} />

        <CourseFilterHelper
          title="Languages"
          name="language"
          items={languages}
          valueKey="Language"
          labelKey="Language"
          form={form}
          showClear={true}
          onClear={() => handleClearFilter("language")}
          isVisible={filterVisibility.language}
          toggle={toggleFilter}
        />

        <Divider style={{ marginTop: 10, marginBottom: 10 }} />

        <CourseFilterHelper
          title="Modes"
          name="mode"
          items={modes}
          valueKey="mode"
          labelKey="mode"
          form={form}
          showClear={true}
          onClear={() => handleClearFilter("mode")}
          isVisible={filterVisibility.mode}
          toggle={toggleFilter}
        />
        {false && (
          <>
            <Divider style={{ marginTop: 10, marginBottom: 10 }} />
            <div style={{ marginInline: 0 }}>
              <div
                className="splitter-first-div"
                onClick={() => toggleFilter("categories")}
              >
                <Typography.Text
                  className="my-form-lables"
                  style={{ marginInline: 10, padding: 0, paddingInline: "5px" }}
                >
                  Categories
                </Typography.Text>

                <Button
                  type="text"
                  icon={
                    filterVisibility.categories ? (
                      <DownOutlined />
                    ) : (
                      <RightOutlined />
                    )
                  }
                  size="small"
                  style={{ marginInline: 10 }}
                />
              </div>
              <Collapse
                activeKey={filterVisibility?.categories ? ["1"] : []}
                ghost
                style={{ margin: 0, padding: 0 }}
              >
                <Panel
                  key="1"
                  showArrow={false}
                  style={{ margin: 0, padding: 0 }}
                >
                  <Input
                    placeholder="Search Categories"
                    value={categorySearch}
                    onChange={(e) => setCategorySearch(e.target.value)}
                    allowClear
                    suffix={<SearchOutlined style={{ color: "#bfbfbf" }} />}
                    style={{ marginTop: 5, marginBottom: 10 }}
                  />
                  {categories?.length > 0 ? (
                    <Form.Item name="categories" style={{ margin: 0 }}>
                      <Tree
                        treeData={convertCategoriesToTreeNodes(
                          categories || [],
                          categorySearch
                        ).map((node) => ({
                          ...node,
                          title: (
                            <div
                              style={{
                                display: "flex",
                                justifyContent: "space-between",
                                alignItems: "center",
                                width: "100%",
                              }}
                            >
                              <span
                                style={{
                                  textOverflow: "ellipsis",
                                }}
                              >
                                {node.title}
                              </span>
                              <span
                                style={{
                                  marginLeft: "auto",
                                  textAlign: "right",
                                  paddingLeft: 10,
                                  fontSize: 12,
                                  color: "#899499",
                                  fontWeight: 600,
                                  letterSpacing: 0.5,
                                }}
                              >
                                {node.count !== undefined
                                  ? node.count
                                  : Math.floor(Math.random() * 100)}
                              </span>
                            </div>
                          ),
                        }))}
                        checkable
                        style={{
                          padding: "5px",
                          maxHeight:
                            origin === "TN_ADMIN"
                              ? "calc(100vh - 78vh)"
                              : "calc(100vh - 74vh)",
                          overflowY: "auto",
                        }}
                        selectable={false}
                        showLine={true}
                        switcherIcon={<CaretDownOutlined />}
                        checkedKeys={checkedKeys}
                        onCheck={handleCheck}
                      />
                    </Form.Item>
                  ) : (
                    <Empty image={Empty.PRESENTED_IMAGE_SIMPLE} />
                  )}
                </Panel>
              </Collapse>
            </div>
          </>
        )}
        <Divider style={{ marginTop: 10, marginBottom: 10 }} />

        {/* Date Range Filter */}
        <div style={{ marginInline: 0 }}>
          <div
            className="splitter-first-div"
            onClick={() => toggleFilter("dateRange")}
          >
            <Typography.Text
              className="my-form-lables"
              style={{ marginInline: 10, padding: 0, paddingInline: "5px" }}
            >
              Date
            </Typography.Text>
            <Button
              type="text"
              icon={
                filterVisibility.dateRange ? (
                  <DownOutlined />
                ) : (
                  <RightOutlined />
                )
              }
              size="small"
              style={{ marginInline: 10 }}
            />
          </div>
          <Collapse
            activeKey={filterVisibility?.dateRange ? ["1"] : []}
            ghost
            style={{ margin: 0, padding: 0 }}
          >
            <Panel
              key="1"
              showArrow={false}
              style={{ margin: 0, padding: 0 }}
            >
              <Form.Item
                name="date_type"
                label={
                  <Typography.Text
                    className="my-form-lables"
                    style={{ fontSize: "13px", fontWeight: 500 }}
                  >
                    Select Date Column
                  </Typography.Text>
                }
                style={{ marginTop: 10, marginBottom: 10 }}
              >
                <Select
                  placeholder="Select date column"
                  allowClear
                  style={{ width: "100%" }}
                  onChange={(value) => {
                    // Clear date range when column is cleared
                    if (!value) {
                      form.setFieldsValue({ dateRange: undefined });
                    }
                  }}
                >
                  <Option value="attended_on">Attended On</Option>
                  <Option value="enrolled_on">Enrolled On</Option>
                  <Option value="completed_on">Completed On</Option>
                </Select>
              </Form.Item>
              <Form.Item
                name="dateRange"
                label={
                  <Typography.Text
                    className="my-form-lables"
                    style={{ fontSize: "13px", fontWeight: 500 }}
                  >
                    Select Date Range
                  </Typography.Text>
                }
                style={{ marginBottom: 10 }}
              >
                <RangePicker
                  disabled={!form.getFieldValue("date_type")}
                  placeholder={["Start Date", "End Date"]}
                  style={{ width: "100%" }}
                  format="YYYY-MM-DD"
                  allowClear
                  disabledDate={(current, { from }) => {
                    // If selecting end date and start date exists, disable dates before start date
                    if (from && current) {
                      return current.isBefore(from, 'day');
                    }
                    return false;
                  }}
                  onChange={(dates) => {
                    // Clear date column when date range is cleared
                    if (!dates || dates.length === 0) {
                      form.setFieldsValue({ date_type: undefined });
                    }
                  }}
                />
              </Form.Item>
              {form.getFieldValue("date_type") || form.getFieldValue("dateRange") ? (
                <Button
                  type="link"
                  size="small"
                  onClick={() => handleClearFilter("dateRange")}
                  style={{ padding: 0, marginBottom: 10 }}
                >
                  Clear Date Filter
                </Button>
              ) : null}
            </Panel>
          </Collapse>
        </div>
        <Divider style={{ marginTop: 10, marginBottom: 10 }} />
      </Form>
    </div>
  );
};

export default RecordsFiltersSplitter;
